import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ArrowDownIcon } from '@chakra-ui/icons';
import { HStack, Input, Text, VStack } from '@chakra-ui/react';
import * as R from 'ramda';
import { Mode } from 'src/types/crudTable';
import { getCellValue } from '../utils';
import { useTableContext } from './useTableContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var defaultRenderWritable = function defaultRenderWritable(value, onUpdate) {
  var isDisabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var handleChange = function handleChange(e) {
    onUpdate(e.target.value);
  };

  return /*#__PURE__*/_jsx(HStack, {
    w: "full",
    h: "full",
    e2eid: "CrudTable_EditableCell_HStack",
    children: /*#__PURE__*/_jsx(Input, {
      bg: "white",
      size: "md",
      borderColor: "blue.500",
      borderWidth: "1.5px",
      value: value,
      onChange: handleChange,
      isDisabled: isDisabled,
      e2eid: "CrudTable_EditableCell_Input"
    })
  });
};

var COLOR = {
  GREEN: '#24B263',
  GRAY: '#A2A2A2'
};

var DefaultPreviewCell = function DefaultPreviewCell(_ref) {
  var prev = _ref.prev,
      next = _ref.next,
      getDisplayValue = _ref.getDisplayValue;
  var isRowChanged = prev !== next;
  var displayPrev = getDisplayValue ? getDisplayValue(prev) : prev;
  var displayNext = isRowChanged && getDisplayValue ? getDisplayValue(next) : next;

  if (!isRowChanged) {
    return /*#__PURE__*/_jsx(Text, {
      whiteSpace: "break-spaces",
      e2eid: "CrudTable_EditableCell_Text",
      children: displayPrev
    });
  } else if (!prev) {
    return /*#__PURE__*/_jsx(Text, {
      whiteSpace: "break-spaces",
      style: {
        color: COLOR.GREEN
      },
      e2eid: "CrudTable_EditableCell_Text_3",
      children: displayNext
    });
  } else if (!next) {
    return /*#__PURE__*/_jsx(Text, {
      whiteSpace: "break-spaces",
      style: {
        color: COLOR.GRAY
      },
      textDecoration: "line-through",
      e2eid: "CrudTable_EditableCell_Text_4",
      children: displayPrev
    });
  } else {
    return /*#__PURE__*/_jsxs(VStack, {
      justify: "flex-start",
      alignItems: "flex-start",
      spacing: 0,
      e2eid: "CrudTable_EditableCell_VStack",
      children: [/*#__PURE__*/_jsx(Text, {
        w: "full",
        whiteSpace: "break-spaces",
        style: {
          color: COLOR.GRAY
        },
        e2eid: "CrudTable_EditableCell_Text",
        children: displayPrev
      }), /*#__PURE__*/_jsx(ArrowDownIcon, {
        marginLeft: 2,
        style: {
          color: COLOR.GRAY
        },
        fontSize: "larger",
        e2eid: "CrudTable_EditableCell_ArrowDownIcon"
      }), /*#__PURE__*/_jsx(Text, {
        whiteSpace: "break-spaces",
        w: "full",
        style: {
          color: COLOR.GREEN
        },
        e2eid: "CrudTable_EditableCell_Text",
        children: displayNext
      })]
    });
  }
};

var EditCell = function EditCell(props) {
  var _useTableContext = useTableContext(),
      updateCell = _useTableContext.updateCell,
      saving = _useTableContext.saving;

  var column = props.column,
      getValue = props.getValue,
      row = props.row;
  var columnMeta = column.columnDef.meta;
  var current = getValue();
  var editable = columnMeta.editable;
  var renderWritable = typeof editable === 'object' && editable.renderEditCell || defaultRenderWritable;

  var onUpdate = function onUpdate(value) {
    updateCell(row.id, column.id, value);
  };

  return renderWritable(current, onUpdate, saving);
};

var PreviewCell = function PreviewCell(props) {
  var _useTableContext2 = useTableContext(),
      originalData = _useTableContext2.originalData;

  var column = props.column,
      getValue = props.getValue,
      row = props.row;
  var columnMeta = column.columnDef.meta;
  var initialValue = getCellValue(column.id, originalData[row.id]);
  var current = getValue();
  return /*#__PURE__*/_jsx(DefaultPreviewCell, {
    prev: initialValue,
    next: current,
    getDisplayValue: columnMeta === null || columnMeta === void 0 ? void 0 : columnMeta.getDisplayValue,
    e2eid: "CrudTable_EditableCell_DefaultPreviewCell"
  });
};

export var EditableCell = function EditableCell(props) {
  var _useTableContext3 = useTableContext(),
      mode = _useTableContext3.mode;

  if (mode === Mode.VIEW) {
    return typeof props.originalCell === 'function' ? props.originalCell(R.omit(['originalCell'], props)) : props.getValue();
  } else if (mode === Mode.PREVIEW) {
    return /*#__PURE__*/_jsx(PreviewCell, _objectSpread(_objectSpread({}, props), {}, {
      e2eid: "CrudTable_EditableCell_PreviewCell"
    }));
  }

  return /*#__PURE__*/_jsx(EditCell, _objectSpread(_objectSpread({}, props), {}, {
    e2eid: "CrudTable_EditableCell_EditCell"
  }));
};